import coreModule from 'app/core/core_module';

export class MatlabPluginSrv {
  request = null;

  /* @ngInject */
  constructor(private $q, private $http) {}

  getUrl() {
    if (window.location.hostname !== 'getcurve.io') {
      // Hardcoded matlab plugin url for internal use
      return Promise.resolve("https://curve-ops.s3.amazonaws.com/Curve-0.9.39-VAST.mlappinstall");
    }

    if (this.request) {
      return this.request;
    }

    this.request = this.$q((resolve, reject) => {
      let url = 'https://curve-ops.s3.amazonaws.com/update.json?r=' + Math.random();
      this.$http.get(url).then(
        response => {
          if (response && response.data && response.data.url) {
            resolve(response.data.url);
          } else {
            reject('Plugin URL: Invalid response.');
          }
        },
        err => {
          throw new Error("Couldn't fetch update.json");
        }
      );
    });

    return this.request;
  }
}

coreModule.service('matlabPluginSrv', MatlabPluginSrv);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/matlab_plugin_srv.ts